import React from 'react';
import Icon from '../AppIcon';
import { cn } from '../../utils/cn';

const Button = React.forwardRef(({ 
  className, 
  variant = "default", 
  size = "default",
  iconName,
  iconPosition = "left",
  children, 
  disabled,
  ...props 
}, ref) => {
  const baseClasses = "inline-flex items-center justify-center rounded-[2px] font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none";
  
  const variants = {
    default: "bg-primary text-primary-foreground hover:bg-primary/90",
    destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
    outline: "border border-input hover:bg-accent hover:text-accent-foreground",
    secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
    ghost: "hover:bg-accent hover:text-accent-foreground",
    link: "underline-offset-4 hover:underline text-primary"
  };

  const sizes = {
    default: "h-10 py-2 px-4",
    sm: "h-9 px-3 rounded-[2px]",
    lg: "h-11 px-8 rounded-[2px]",
    icon: "h-10 w-10"
  };

  const renderIcon = () => {
    if (!iconName) return null;
    
    const iconSize = size === 'sm' ? 14 : size === 'lg' ? 18 : 16;
    const iconClasses = children 
      ? (iconPosition === 'left' ? 'mr-2' : 'ml-2')
      : '';
    
    return (
      <Icon 
        name={iconName} 
        size={iconSize} 
        className={iconClasses}
      />
    );
  };

  return (
    <button
      className={cn(
        baseClasses,
        variants?.[variant],
        sizes?.[size],
        className
      )}
      ref={ref}
      disabled={disabled}
      {...props}
    >
      {iconPosition === 'left' && renderIcon()}
      {children}
      {iconPosition === 'right' && renderIcon()}
    </button>
  );
});

Button.displayName = "Button";

export default Button;